import axios from 'axios'

import { AUTH_TOKEN_STORAGE_KEY } from '@/constants'
import storage from '@/utils/storage'
import urls from './urls'

const axiosClient = axios.create({
  baseURL: urls.base,
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * Include auth token in header if exists
 */
axiosClient.interceptors.request.use(config => {
  const { url } = config

  // Exclude login and register requests from sending token
  if (![urls.auth.login(), urls.auth.register()].includes(url)) {
    const authToken = storage.load(AUTH_TOKEN_STORAGE_KEY)

    if (authToken) {
      config.headers.Authorization = `Token ${authToken}`
    }
  }

  return config
})

export function uploadFile (url, file, fileType) {
  if (!fileType) fileType = file.type

  return axiosClient
    .put(url, file, {
      headers: {
        'Content-Type': fileType,
        'Content-Disposition': 'attachment; filename=' + encodeURIComponent(file.name)
      }
    })
}

export function uploadVideo (formData, file) {
  var form = new FormData()
  for (var key in formData) {
    form.append(key, formData[key])
  }
  form.append('file', file)

  // workaround for https://github.com/axios/axios/issues/1522
  var defaultHeaders = axios.defaults.headers.common
  axios.defaults.headers.common = {}

  var req = axios.post(urls.videoUpload, form, {
    responseType: 'document',
    headers: {}
  })

  axios.defaults.headers.common = defaultHeaders

  return req
}

export class PaginatedResponse {
  constructor (data) {
    if (!data) {
      this.count = 0
      this.results = []
      this._previous = null
      this._next = null
      return
    }
    this.count = data.count || 0
    this.results = data.results || []
    this._previous = data.previous
    this._next = data.next
  }

  next () {
    if (!this._next) {
      return Promise.resolve(new PaginatedResponse())
    }

    return axiosClient
      .get(this._next)
      .then(response => new PaginatedResponse(response.data))
  }

  previous () {
    if (!this._previous) {
      return Promise.resolve(new PaginatedResponse())
    }

    return axiosClient
      .get(this._previous)
      .then(response => new PaginatedResponse(response.data))
  }

  async all () {
    let items = []
    let page = this

    while (page.count > 0) {
      for (let item of page.results) {
        items.push(item)
      }
      page = await page.next()
    }

    return items
  }
}

export default axiosClient



// WEBPACK FOOTER //
// ./src/utils/client.js